update_free_shipping_progress_bar_widgets();

function update_free_shipping_progress_bar_widgets(){
    let free_shipping_progress_bar_widgets = document.getElementsByClassName("free-shipping-progress-bar-widget");

    if(free_shipping_progress_bar_widgets.length > 0){
        for (let widget of free_shipping_progress_bar_widgets) {
            let free_shipping_text = '';

            let cart_total = widget.dataset.cartTotal;
            let free_shipping_threshold = widget.dataset.freeThreshold;
            let expedited_shipping_threshold = widget.dataset.expressThreshold;

            let free_shipping_spend_required = free_shipping_threshold - cart_total;
            let expedited_shipping_spend_required = expedited_shipping_threshold - cart_total;

            let progress_bar_width = 0;

            // adjust free shipping progress bar
            if (
                free_shipping_spend_required > 0 && free_shipping_spend_required != free_shipping_threshold
            ){
                let progress_bar_percent = 100 / free_shipping_threshold;
                progress_bar_width = progress_bar_percent * cart_total;
            }

            // adjust free express shipping progress bar
            if (free_shipping_spend_required <= 0){
                
                progress_bar_width = 100;
                
                if (
                    expedited_shipping_threshold != 0 && (
                        expedited_shipping_spend_required > 0 && expedited_shipping_spend_required != expedited_shipping_threshold)
                ){
                    let progress_bar_percent = 100 / expedited_shipping_threshold;
                    progress_bar_width = progress_bar_percent * cart_total;
                }

            }

            // assemble free shipping text
            if( free_shipping_spend_required > 0 ){
                let free_shipping_spend_required_text = free_shipping_spend_required / 100;
                free_shipping_text = 'Spend ' + convert_to_currency(free_shipping_spend_required_text) + ' more for free standard delivery';
            } else if(expedited_shipping_threshold != 0) {
                if (expedited_shipping_spend_required > 0){
                    let expedited_shipping_spend_required_text = expedited_shipping_spend_required / 100;
                    free_shipping_text = '<strong>Free standard delivery unlocked!</strong><br/>Spend ' + convert_to_currency(expedited_shipping_spend_required_text) + ' more for free express delivery';
                } else {
                    free_shipping_text = '<strong>Free express delivery unlocked!</strong>';
                }
            } else {
                free_shipping_text = '<strong>Free standard delivery unlocked!</strong>';
            }

            progress_bar_width = progress_bar_width > 100 ? 100 : progress_bar_width;

            // set free shipping text
            widget.children[0].innerHTML = free_shipping_text;

            // set progress bar width
            widget.children[1].children[0].style.width = progress_bar_width + '%';

            // watch for changes in the data attributes (i.e. cart total amount) and update the cart widget when this happens
            const observer = new MutationObserver(update_free_shipping_progress_bar_widgets);
            observer.observe(widget, { attributes: true });
        }
    }
}

function convert_to_currency(amount){
    if( document.body.classList.contains('uk') ){
        amount = amount.toLocaleString('en-GB', {
            style: 'currency',
            currency: 'GBP'
        });
    }
    if( document.body.classList.contains('us') ){
        amount = amount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });
    }
    if( document.body.classList.contains('eu') ){
        amount = '€' + amount.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
    return amount;
}

const mutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type !== "attributes" ||
        mutation.attributeName !== "data-foo"
      ) {
        return
      }
    }
  }